import React from "react";
import { GetYear } from "../utils/GetYear";
import StandardNavbar from "./StandardNavbar";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./MainNavbar";

function HelpMain() {
    const {pathname} = useLocation()
    let hasNavitem = pathname.includes("/help/")
    console.log("sxsx",hasNavitem);
    
  return (
    <div className=" w-full h-full overflow-hidden">
      <div className=" w-full h-[60px]">
        {
            hasNavitem ? <StandardNavbar />: <Navbar/>
        } 
      </div>
      <div className="w-[100%] h-[calc(100vh-80px)]">
        <Outlet />
      </div>
      <div className=" w-full h-5 ">
        <p className=" text-slate-400 text-center w-full text-xs">
          <span className=" text-[15px] font-medium">&copy;</span> {GetYear()}{" "}
          <a href="https://www.metatroninfotech.com/" target="_blank">Metatron Infotech.</a>
        </p>
      </div>
    </div>
  );
}

export default HelpMain;
